let baseUrl = "";
console.log(process.env.NODE_ENV)
switch (process.env.NODE_ENV) { //注意变量名是自定义的
    case 'development':
        // baseUrl = "http://192.168.2.151:8080"
        baseUrl = "https://lhyg-api.cailian.net/"  //开发环境url
        // baseUrl="https://api.ctx666.cn"
        // baseUrl = "http://192.168.2.83:8080"
        break
    case 'uat':
        baseUrl = "https://lhyg-api.cailian.net/"   //测试环境url
        break
    case 'production':
        baseUrl = "https://api.ctx666.cn"   //生产环境url
        break
}
 
export default baseUrl;